<template>
  <div id="app">
    <h3 @click="back" style="border-bottom:1px solid #ccc;padding:0px 0 10px 10px;cursor:pointer">返回</h3>
    <div v-show="isLoading">
      <div class="info">
        <img class=""  :src="task.results!=null?task.results[0].targetPic:''"/>
        <div class=" mid">
          <div class="title">报告名称</div>
          <div class="desc">比对{{webCount}}个网址，共{{resultCount}}处相似。</div>
          <div class="date">时间：{{task.startDate}} 至 {{task.endDate}}</div>
          
        </div>
        <button class="btn" @click="dowFile()">下载报告</button>
        <div class="clear_both"></div>
    </div>
    <div class="guhua">
      <div class="intro">证据固化类型介绍</div>
      <div class="intro" style="color:red">注：监测比对出来的涉嫌侵权链接如不尽快进行固化取证，相关链接有可能因商品下架，内容更换等原因导致证据消失</div>
      <div class="project">网页固化</div>
      <div class="content">介绍</div>
      <div class="project">网购过程数据固化</div>
      <div class="content">介绍</div>
      <div class="project">网购收货过程固化</div>
      <div class="content">介绍</div>
    </div>
    <div class="compare">
      <div>比对结果<span>（{{resultCount}}）</span></div>
      <button @click="book">确认预约证据固化</button>
      <div class="clear_both"></div>
    </div>

    <div class="result">
        <ul class="item">
          <li v-for="(item,key) in task.results" :key="key" class="i">
            <img class="thumb" :src="(item.targetPic)"/>
            <div class="link">{{item.targetLink}}</div>
            <div class="opt">
              <ul>
                <li><input @click="addGuhua(1,item.rid)" type="checkbox"/><label>网页固化</label></li>
                <li><input @click="addGuhua(2,item.rid)" type="checkbox"/><label>网购过程数据固化</label></li>
                <li><input @click="addGuhua(3,item.rid)" type="checkbox"/><label>网购收货过程固化</label></li>
              </ul>
            </div>
            <div class="clear_both"></div>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="!isLoading">
      <h2>不存在监测数据</h2>
    </div>
  </div>
</template>

<style scoped src="../../../static/css/Common.css"></style>
<style scoped src="../../../static/css/Report.css"></style>

<script>
import {taskSummaryApi } from '@/service/allApi'
export default {
  data(){
    return {
      taskId:0,
      task:{},
      webCount:0,
      resultCount:0,
      guhuaWeb:[],
      guhuaBuy:[],
      guhuaRecieve:[],
      isLoading:true
    }
  },

  mounted(){
    this.taskId = this.$route.query.taskId
    this.loadData()
  },
  methods:{
    book(){
      if(this.guhuaWeb.length > 0 ||
         this.guhuaBuy.length > 0 ||
         this.guhuaRecieve.length > 0 ){
        const w = this.guhuaWeb.join(",")
        const b = this.guhuaBuy.join(",")
        const r = this.guhuaRecieve.join(",")
        const url = "/appointment?w=" + w + "&b=" + b + "&r=" + r
        window.location.href = url
      }else{
        alert("请选择需要固化的链接");r
      }
    },
    back(){
      window.location.href = "/history"
    },
    addArray(arr,val){
      if(arr.indexOf(val) == -1){
        arr.push(val)
      }
    },
    addGuhua(type,rid){
      switch(type){
        case 1:
          this.addArray(this.guhuaWeb,rid)
          break;
        case 2:
          this.addArray(this.guhuaBuy,rid)
          break;
        case 3:
          this.addArray(this.guhuaRecieve,rid)
          break;
      }
      // console.log(this.guhuaWeb)
      // console.log(this.guhuaBuy)
      // console.log(this.guhuaRecieve)
    },
    async loadData(){
      const option = {
        taskId:this.taskId
      }
      const res = await taskSummaryApi(option)
   
      if(res.data.code == 100){
        if(res.data.data.results.length>0){
          this.task = res.data.data
          this.webCount = this.task.wid.split(',').length
          this.resultCount = this.task.results.length
          this.isLoading = true
        }else{
          this.isLoading = false
        }
      }
    },
    async  dowFile(){
      if(this.resultCount <= 0){
          this.$message({
            message: '不存在相似处，下载报告失败',
            type: 'error'
          });
          return
      }
      // var data = {
      //     taskId:this.taskId
      // }

      window.open('/api/file/resultDow?taskId='+this.taskId, '_blank')
      // window.open("http://www.dmid.com.cn/api/file/resultDow?taskId="+this.taskId, '_blank')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/iframe/Report.vue